import { PhoneNumber } from '@fmnts/common/phone';
import * as Fn from 'effect/Function';
import * as O from 'effect/Option';
import * as P from 'effect/Predicate';

export type FieldValue = string;

/**
 * Transforms the default value of a phone field.
 *
 * If the given value contains more than just a country code, the formatted phone number is returned.
 * Otherwise, an empty string is returned (e.g. for inputs like `+43` or `001`).
 */
export const transformDefaultValue = (value: unknown): string =>
  Fn.pipe(
    value,
    O.liftPredicate(P.isString),
    O.map(PhoneNumber.parse),
    O.flatMap(O.liftPredicate(PhoneNumber.hasPhoneNumber)),
    O.map(PhoneNumber.format),
    O.getOrElse(Fn.constant('')),
  );

/** Validates values passed via `writeValue`. */
export const validateWriteValue = P.or(P.isString, P.isNull);
